import React from 'react';
import formattingUtils from '../../../Utils/formattingUtils';

const PackageStructureProductRow = ({ product }) => {
    return (
        <div className="simulation-product-row">
            <span className="product-bullet">•</span>
            <span className="product-name">{product.name}</span>
            <span className="price-value">{formattingUtils.currencyFormatter(product.price)}</span>
        </div>
    );
};

export default PackageStructureProductRow;
